<template>
  <el-container class="lx-top-container" style="width: 100%; height: 100%;" direction="vertical">
    <lx-header></lx-header>
    <el-main class="lx-top-container-main" style="background-color: #F4F6FA; padding-top: 15px; width: 100%; height: 100%;">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import Header from '@/components/common/Header'

export default {
  components: {
    'lx-header': Header
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LexueContainer.vue